<template>
  <com-header title="订单查询">
    <div class="check_order">
      <van-form ref="myform" @submit="onSubmit" label-width="0" :show-error-message="false">
        <van-field v-model="formData.mobile" name="mobile" type="tel" clearable placeholder="请输入正确的手机号" :rules="[{ validator:checkMobile, message: '请输入正确手机号' }]" />

        <van-field v-model="formData.verCode" name="verCode" center clearable placeholder="请输入短信验证码" :rules="[{ required:true, message: '请输入短信验证码' }]">
          <template #button>
            <van-button size="small" type="primary" :disabled="downTime > 0" native-type="button" @click="sendCode">{{
                  downTime > 0 ? downTime + "秒后重发" : "发送验证码"
                }}</van-button>
          </template>
        </van-field>

        <div class="btn">
          <van-button type="danger" native-type="submit" :loading="loading">确认</van-button>
        </div>
      </van-form>
    </div>

    <van-dialog v-model="visible" :show-confirm-button="false" :closeOnClickOverlay="true">
      <div class="item" v-for="(v,i) in orderList" :key="i">
        <van-button size="small" type="info" native-type="button" @click="linkOrder(v)">{{v.name}}</van-button>
      </div>
    </van-dialog>
  </com-header>
</template>

<script>
import {
  GetCustomerOrder,
  GetLoginVerCode,
} from "@/pages/page1/api-work/index";
import ComHeader from "./components/comHeader";
import { Dialog, Form, Field, Button } from "vant";
import { validMobile } from "@/pages/publicUtils/validate";
export default {
  components: {
    ComHeader,
    [Dialog.Component.name]: Dialog.Component,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
  },
  data() {
    return {
      visible: false,
      formData: {
        mobile: undefined,
        verCode: undefined,
      },
      loading: false,
      downTime: 0,
      orderList: [],
    };
  },
  methods: {
    sendCode() {
      this.$refs.myform.validate("mobile").then(() => {
        GetLoginVerCode({ mobile: this.formData.mobile }).then((res) => {
          // console.log("获取到的验证码", res);
          this.formData.verCode = res.data[0].verCode;
          this.downTime = 60;
          let aTime = setInterval(() => {
            this.downTime -= 1;
            if (this.downTime <= 0) {
              clearInterval(aTime);
            }
          }, 1000);
        });
      });
    },
    onSubmit(values) {
      // console.log(values);
      this.loading = true;
      GetCustomerOrder(values)
        .then((res) => {
          // console.log("订单列表", res);
          this.loading = false;
          this.orderList = res.data;
          if (this.orderList.length === 1) {
            this.linkOrder(this.orderList[0]);
            return;
          }
          this.visible = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    linkOrder(v) {
      let showWay = this.actionShowData(v.orderSignPrintSet);
      this.$router.push({
        path: "/checkOrderResult",
        query: { sign: v.orderSign, showWay },
      });
    },
    // 使用参数B处理
    actionShowData(orderSignPrintSet) {
      let arr = orderSignPrintSet.split("#");
      // console.log(arr);
      let obj = {};
      arr.forEach((v) => {
        let arrItem = v.split("_");
        obj[arrItem[0]] = arrItem[1];
      });
      // console.log(obj);
      return obj.showWay;
    },
    // 验证
    checkMobile(val) {
      return validMobile(val);
    },
  },
};
</script>

<style lang="less" scoped>
.check_order {
  padding: 2rem 1rem;
  /deep/ .van-form {
    .van-cell {
      border: 1px solid rgb(215, 215, 215);
      margin-top: 20px;
      padding: 0 16px;
      line-height: 40px;
      .van-field__button {
        position: relative;
        left: 16px;
        top: -4px;
        height: 40px;
        .van-button {
          background: @themeColor;
          border: 1px solid @themeColor;
          height: 100%;
        }
      }
    }
  }
  .btn {
    margin-top: 60px;
    .van-button {
      width: 100%;
      height: 40px;
      background: rgb(217, 0, 27);
    }
  }
}
.van-dialog {
  /deep/ .van-dialog__content {
    background: rgb(242, 242, 242);
    padding: 1rem;
    max-height: 5.8rem;
    overflow: auto;
    .item {
      margin-bottom: 15px;
      &:last-child {
        margin-bottom: 0;
      }
      .van-button {
        width: 100%;
        height: 40px;
      }
    }
  }
}
</style>